<div fxLayout="column" fxLayoutAlign=" center" style="position:relative">
  <button class="close-button" (click)="closeDialog()">
    <div
      class="global-icon"
      style="
        width: 24px;
        height: 24px;
        mask-image: url('assets/icons/times-icon.svg');
        -webkit-mask-image: url('assets/icons/times-icon.svg');
        background-color: currentColor;
      "
      alt="times icon"
    ></div>

  </button>
  <img alt="erreur" src="assets/images/new-request.svg" />
  <div *ngIf="!data.isCreated">
  <h1>Votre demande est en cours de validation</h1>
  <h2>
    Vous avez envoyé une demande d'adhésion à <b>{{ data.company }}</b> .
    Vous serez notifié une fois votre demande confirmée par son Administrateur <b>{{ data.email }}</b>.
  </h2>
</div>
  <div *ngIf="data.isCreated">
    <h1>Votre demande est en cours de validation</h1>
    <h2>
      Vous avez envoyer une demande de création de la société  <b>{{ data.company }}</b>
      . Vous serez notifié une fois votre demande confirmée par l'équipe Imtech.
    </h2>
  </div>
  <button mat-button class="app-flat-button" (click)="closeDialog()">
    continuer
  </button>
</div>
